import {
  AUTH_EMAIL_LOGIN,
  AUTH_LINK_TO_PAY_EXPIRED,
  AUTH_LOGIN,
  AUTH_MAGIC_LINK_CONFIRMATION,
  AUTH_MAGIC_LINK_LOGIN,
  AUTH_MFA_LOCKED,
  AUTH_MFA_PAGE,
  AUTH_MFA_UPDATE_PHONE,
  AUTH_PASSWORD_EDIT,
  AUTH_PASSWORD_NEW,
  AUTH_PASSWORD_RESET_CONFIRMATION,
  AUTH_ROUTES,
  AUTH_SF_LOCKED,
  PORTAL
} from 'portal/constants/Routes';

import { reject } from 'lodash';
import { useNavigate, useRoutes } from 'react-router-dom';
import AccountLockedContents from 'portal/home/AccountLockedContents';
import AuthLogin from 'auth/AuthLogin';
import AuthMagicLinkConfirm from 'auth/magic_link/AuthMagicLinkConfirm';
import AuthMagicLinkLogin from 'auth/magic_link/AuthMagicLinkLogin';
import AuthPasswordEdit from 'auth/reset_password/AuthPasswordEdit';
import AuthPasswordNew from 'auth/reset_password/AuthPasswordNew';
import AuthPasswordResetConfirmation from 'auth/reset_password/AuthPasswordResetConfirmation';
import Cookies from 'js-cookie';
import EmailPasswordLogin from 'auth/EmailPasswordLogin';
import ExpiredLinkToPay from 'auth/ExpiredLinkToPay';
import MfaLocked from 'auth/MfaLocked';
import MfaLogin from 'auth/MfaLogin';
import React from 'react';
import Redirect from 'portal/Redirect';
import UpdatePhone from 'auth/UpdatePhone';

const routeNotImplemented = ({ path }) => {
  if (path === '*') return false;
  return !AUTH_ROUTES.includes(path);
};

const routes = () => {
  const navigate = useNavigate();

  if (Cookies.get('token')) {
    window.location.href = PORTAL;
  }

  const all = [
    {
      path: AUTH_LOGIN,
      element: <AuthLogin navigate={navigate} />
    },
    {
      path: AUTH_EMAIL_LOGIN,
      element: <EmailPasswordLogin navigate={navigate} />
    },
    {
      path: AUTH_MFA_PAGE,
      element: <MfaLogin navigate={navigate} />
    },
    {
      path: AUTH_MFA_LOCKED,
      element: <MfaLocked navigate={navigate} />
    },
    {
      path: AUTH_PASSWORD_NEW,
      element: <AuthPasswordNew navigate={navigate} />
    },
    {
      path: AUTH_PASSWORD_EDIT,
      element: <AuthPasswordEdit navigate={navigate} />
    },
    {
      path: AUTH_SF_LOCKED,
      element: <AccountLockedContents navigate={navigate} />
    },
    {
      path: AUTH_MFA_UPDATE_PHONE,
      element: (
        <UpdatePhone
          navigate={navigate}
          accountLockedPath={AUTH_SF_LOCKED}
          backPath={AUTH_MFA_PAGE}
          updateCompletePath={`${AUTH_MFA_PAGE}?phone_update_complete=true`}
        />
      )
    },
    {
      path: AUTH_MAGIC_LINK_LOGIN,
      element: <AuthMagicLinkLogin navigate={navigate} />
    },
    {
      path: AUTH_LINK_TO_PAY_EXPIRED,
      element: <ExpiredLinkToPay />
    },
    {
      path: AUTH_PASSWORD_RESET_CONFIRMATION,
      element: <AuthPasswordResetConfirmation navigate={navigate} />
    },
    {
      path: AUTH_MAGIC_LINK_CONFIRMATION,
      element: <AuthMagicLinkConfirm navigate={navigate} />
    },
    {
      path: '*',
      element: <Redirect />
    }
  ];

  return reject(all, (route) =>
    routeNotImplemented({
      path: route.path
    })
  );
};

export const AuthRouter = () => {
  return useRoutes(routes());
};
